import { useMemo, useState } from "react";
import { number, object } from "prop-types";
import { BreakdownTableDepths } from "@repo/utils";
import { TableHeader } from "../TableHeader/TableHeader";
import { BreakdownRowGroup } from "../BreakdownRowGroup/BreakdownRowGroup";
import { SectionContainer } from "./SectionContainer";

export const Section = ({
  section,
  index,
}) => {
  const [ headerRef, setHeaderRef ] = useState(null);

  const tableIdentifier = useMemo(() => `tableHeader${index}`, [index]);
  
  return (
    <SectionContainer
      index={index}
      section={section}
      headerRef={headerRef}
    >
      <TableHeader
        ref={setHeaderRef}
        section={ section }
        tableIdentifier={ tableIdentifier }
      />
      <BreakdownRowGroup
        sectionIndex={ index }
        element={ section }
        isLastGroupRow
        tableDepth={ BreakdownTableDepths.SECTION }
        isFirst={ index === 0 }
      />
    </SectionContainer>
  );
};

Section.propTypes = {
  section: object.isRequired,
  index: number.isRequired,
};
